(function (angular) {
    'use strict';

    angular.module('chat2')
        // This orders the chats based on the type 
        // assumption is that all messages are of the same type ... 
        .filter('chat2Filter', ["jwtService", function (jwtService) {


            function getAgent(chat) {
                var profileId;

                angular.forEach(chat.participants, function (participant) {
                    if (participant.role === "agent") {
                        profileId = participant.id;
                    }
                });

                return profileId;
            }

            /**
             * Filter the conversations based on a combination of status ["profile", "all"] and scope ["open", "new", "replied", "closed"]
             * {Object[]} items - The chats
             * {String} status - The status ["profile", "all"]
             * {String} scope - The scope ["open", "new", "replied", "closed"]
             * {String} teamId - The teamId or undefined for all teams
             */
            return function (items, status, scope, teamId) {
                var filtered = items;
                var sorted = [];

                if (items && items.length > 0) {

                    switch (status) {
                        case "open":
                            filtered = items.filter(function (chat) { return chat.status !== "closed" });
                            break;

                        case "new":
                            filtered = items.filter(function (chat) { return chat.status === "new" });
                            break;

                        case "replied":
                            filtered = items.filter(function (chat) { return chat.status === "replied" });
                            break;

                        case "closed":
                            filtered = items.filter(function (chat) { return chat.status === "closed" });
                            break;
                    }


                    // if scope === "profile", we need to filter out all chats that the logged in user is NOT the agent
                    if (scope === "profile" && filtered.length > 0) {
                        filtered = filtered.filter(function (chat) {
                            // agent will include "PLATFORMUSER\{profileId}"
                            var agent = getAgent(chat);

                            if (agent && _.isString(agent)) {
                                return agent.indexOf(jwtService.payload.sub) !== -1;
                            } else {
                                // This is a valid state - chat is probably just assigned to a team
                                // console.error("Failed to get agent from chat", chat);
                                return false;
                            }

                        });
                    }

                    if (teamId && filtered.length > 0) {
                        filtered = filtered.filter(function (chat) {
                            return chat.teamId === teamId;
                        });

                    }

                    if (filtered.length > 0) {
                        // are these open chats or closed 
                        // the assumption is if the first one is closed, they all are ...
                        if (filtered[0].status === "closed") {
                            // closed, just sort by lastMessageTimestamp - DESCENDING

                            sorted = filtered.sort(function (a, b) {
                                return a.lastMessageTimestamp > b.lastMessageTimestamp ? -1 : a.lastMessageTimestamp < b.lastMessageTimestamp ? 1 : 0;
                            });

                        } else {

                            // open - split into 2 arrays new and replied, sort individually and concat

                            // new ones sorted by lastMessageTimestamp - ASCENDING
                            var newItems = filtered.filter(function (c) {
                                return c.status === "new";
                            });

                            newItems.sort(function (a, b) {
                                return a.lastMessageTimestamp > b.lastMessageTimestamp ? 1 : a.lastMessageTimestamp < b.lastMessageTimestamp ? -1 : 0;
                            });

                            // replied ones sorted by lastMessageTimestamp - ASCENDING
                            var repliedItems = filtered.filter(function (c) {
                                return c.status === "replied";
                            });

                            repliedItems.sort(function (a, b) {
                                return a.lastMessageTimestamp > b.lastMessageTimestamp ? 1 : a.lastMessageTimestamp < b.lastMessageTimestamp ? -1 : 0;
                            });

                            sorted = newItems.concat(repliedItems);
                        }
                    }
                }
                return sorted;
            };
        }]);

})(window.angular);

